import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'subTypeFormat',
    pure: true,
    standalone: false
})
export class SubTypeFormatPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(row: any, ...args: unknown[]): string {
    return row.subtype !== 'old_anomaly'
      ? this.translateService.instant(`modules.mission.service.anomaly.type.` + row.subtype)
      : row.type;
  }
}